module.exports = __webpack_public_path__ + "static/media/emailYesterDayOne.df7229a6.png";